// src/services/userService.js

import API from './api';

/*
|--------------------------------------------------------------------------
| GET USERS
|--------------------------------------------------------------------------
*/

export const getUsers = async (
    page = 1,
    search = '',
    status = 'all'
) => {

    try {

        const response = await API.get(
            `/admin/users?page=${page}&search=${search}&status=${status}`
        );

        return response.data;

    } catch (error) {

        throw (
            error.response?.data || {
                status: false,
                message: 'Failed to fetch users'
            }
        );

    }

};

/*
|--------------------------------------------------------------------------
| GET SINGLE USER
|--------------------------------------------------------------------------
*/

export const getSingleUser = async (
    userId
) => {

    try {

        const response = await API.get(
            `/admin/client/details?user_id=${userId}`
        );

        return response.data;

    } catch (error) {

        throw (
            error.response?.data || {
                status: false,
                message: 'Failed to fetch user details'
            }
        );

    }

};

/*
|--------------------------------------------------------------------------
| BLOCK USER
|--------------------------------------------------------------------------
*/

export const blockUser = async (
    userId
) => {

    try {

        const response = await API.post(
            `/admin/block-user`,
            {
                user_id: userId
            }
        );

        return response.data;

    } catch (error) {

        throw (
            error.response?.data || {
                status: false,
                message: 'Failed to block user'
            }
        );

    }

};

/*
|--------------------------------------------------------------------------
| ACTIVATE USER
|--------------------------------------------------------------------------
*/

export const activateUser = async (
    userId
) => {

    try {

        const response = await API.post(
            `/admin/activate-user`,
            {
                user_id: userId
            }
        );

        return response.data;

    } catch (error) {

        throw (
            error.response?.data || {
                status: false,
                message: 'Failed to activate user'
            }
        );

    }

};

/*
|--------------------------------------------------------------------------
| TOGGLE INVESTOR STATUS
|--------------------------------------------------------------------------
*/

export const toggleInvestorStatus = async (
    userId,
    status
) => {

    try {

        const response = await API.post(
            `/admin/investor-status`,
            {
                user_id: userId,
                status: status
            }
        );

        return response.data;

    } catch (error) {

        throw (
            error.response?.data || {
                status: false,
                message: 'Failed to toggle investor status'
            }
        );

    }

};

/*
|--------------------------------------------------------------------------
| TOPUP USER ACCOUNT
|--------------------------------------------------------------------------
*/

export const topupUser = async (
    userId,
    amount
) => {

    try {

        const response = await API.post(
            `/admin/topup`,
            {
                user_id: userId,
                amount: amount
            }
        );

        return response.data;

    } catch (error) {

        throw (
            error.response?.data || {
                status: false,
                message: 'Failed to process topup'
            }
        );

    }

};